<template>
  <div class="kk_format-item" :class="{ 'kk_format-item-active': isActive }" @click="click">
    <custom-icon :class-name="format.icon" :icon-color="'#083277'" />
    <div>{{ format.text }}</div>
  </div>
</template>
<script>
import { tree } from "../../../../store/RangeStyle";
import CustomIcon from "../../../commons/CustomIcon.vue";
import { NumberFormats } from "../../../../utils/DataTypeUtils";
import DesignerMixin from "../../../process-design/DesignerMixin";
export default {
  components: {
    CustomIcon,
  },
  mixins: [DesignerMixin],
  props: ["format"],
  computed: {
    redrawCanvas() {
      return this.$store.state.cells.redrawCanvas;
    },
    activeCellRowIndex() {
      if (!this.activeCellId) return null;
      const [rowId] = this.activeCellId.split("_");
      return this.rowMap[rowId].index;
    },
    activeCellColumnIndex() {
      if (!this.activeCellId) return null;
      const [, columnId] = this.activeCellId.split("_");
      return this.columnMap[columnId].index;
    },
    isActive() {
      const dataTypeResult = tree.search({
        minX: this.activeCellColumnIndex,
        minY: this.activeCellRowIndex,
        maxX: this.activeCellColumnIndex,
        maxY: this.activeCellRowIndex,
      });
      // redraw canvas is only used to cause this property to recalculate when a data type is added to tree.
      // because changing dataTypetree doesn't cause recalculation
      if (this.redrawCanvas && dataTypeResult.length > 0 && dataTypeResult[0].data.dataType === this.format.type)
        return true;
      else if (this.activeCellId && dataTypeResult.length === 0 && this.format.type === NumberFormats.General)
        return true;
      return false;
    },
  },
  methods: {
    click() {
      if (this.activeCellId)
        this.$store.dispatch("rangeStyle/updateRangeStyle", {
          data: {
            dataType: this.format.type,
          },
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";
.kk_format-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: @kk-border-radius;
  color: @kk-color-primary-blue;
  font-size: 15px;
  cursor: pointer;
  &-active {
    background-color: @kk-color-light-blue;
  }
  &:hover {
    background-color: @kk-color-light-blue;
  }
  :deep(i) {
    font-size: 20px;
  }
}
</style>
